import PropTypes from 'prop-types';

export interface Config {
    appdomain: number;
    isEnabled: (feature: string) => boolean;
    getUrl: (path: string) => string;
    getCountryCode: () => string;
    getSwitchUrlAppdomains: () => {[appdomainId in string]: string};
    getCountryCodeForAppdomainId: (appdomainId: string) => string;
    isPriveDomain: boolean;
}

const configShape = PropTypes.shape({
    isEnabled: PropTypes.func.isRequired,
    getUrl: PropTypes.func.isRequired,
    getCountryCode: PropTypes.func.isRequired,
});

export default configShape;
